import script from "./Finish.vue?vue&type=script&setup=true&lang=ts"
export * from "./Finish.vue?vue&type=script&setup=true&lang=ts"

import "./Finish.vue?vue&type=style&index=0&id=55357659&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55357659"]])

export default __exports__